/** @typedef {'OFF'|'ALL'|'EXCEPT_MENTION'} MuteMode */

export function normalizeMuteMode(convOrMode) {
  if (convOrMode == null) return 'OFF';
  if (typeof convOrMode === 'string') {
    const m = convOrMode.toUpperCase();
    if (m === 'ALL' || m === 'EXCEPT_MENTION' || m === 'OFF') return m;
    return 'OFF';
  }
  const mode = normalizeMuteMode(convOrMode.muteMode);
  if (mode !== 'OFF') return mode;
  // legacy boolean
  if (convOrMode.muted === true) return 'ALL';
  return 'OFF';
}

export function muteLabel(mode) {
  switch (normalizeMuteMode(mode)) {
    case 'ALL':
      return '全靜音';
    case 'EXCEPT_MENTION':
      return '靜音（@仍提示）';
    default:
      return '';
  }
}

/** FAB／紅點是否應提示此會話未讀 */
export function shouldAlertUnread(conv) {
  const unread = Number(conv?.unreadCount) || 0;
  if (unread <= 0) return false;
  const mode = normalizeMuteMode(conv);
  if (mode === 'ALL') return false;
  if (mode === 'EXCEPT_MENTION') return !!conv?.hasUnreadMention;
  return true;
}

export function messageMentionsMember(message, memberId) {
  if (!message || memberId == null) return false;
  return (message.mentions || []).some((m) => String(m.memberId) === String(memberId));
}
